"use client";
import React from "react";

type GaugeMeterProps = {
  value: number | string;
  max: number;
};

const ConsistencyScore = React.memo(function ConsistencyScore({ value, max = 10 }: GaugeMeterProps) {
  // const isValid = Number.isFinite(value) && Number.isFinite(max) && max > 0 && Number.isFinite(radius);

  // const percentage = isValid ? value / max : 0;
  // const circumference = isValid ? Math.PI * radius : 0;
  // const dashOffset = isValid ? circumference * (1 - percentage) : 0;

  const radius = 90;
  const strokeWidth = 18;
  const diameter = radius * 2;
  const cy = radius + strokeWidth;
  const circumference = Math.PI * radius;
  const progress = Math.min(Number(value) / max, 1);
  const dashOffset = circumference * (1 - progress);

  return (
    <div className="relative m-auto" style={{ width: diameter + strokeWidth * 2, height: radius + strokeWidth * 2 }}>
      <svg
        width={diameter + strokeWidth * 2}
        height={radius + strokeWidth * 2}
        viewBox={`0 0 ${diameter + strokeWidth * 2} ${radius + strokeWidth * 2}`}
      >
        <path
          d={`M ${strokeWidth} ${cy} A ${radius} ${radius} 0 0 1 ${diameter + strokeWidth} ${cy}`}
          fill="none"
          stroke="#BACFFD"
          strokeWidth={strokeWidth}
          strokeLinecap="round"
        />
        <path
          d={`M ${strokeWidth} ${cy} A ${radius} ${radius} 0 0 1 ${diameter + strokeWidth} ${cy}`}
          fill="none"
          stroke="#1D26D8"
          strokeWidth={strokeWidth}
          strokeDasharray={circumference}
          strokeDashoffset={dashOffset}
          strokeLinecap="round"
        />
      </svg>
      <div className="absolute bottom-2 left-1/2 -translate-x-1/2 text-2xl transition-all duration-350 ease-linear font-semibold text-primaryBlue">
        {value}
        <span className="text-primaryBlack">/{max}</span>
      </div>
    </div>
  );
});

export default ConsistencyScore;
